<template>
    <div class="page reserva">
		<!-- <MenuOpcion :titulo="titulo">
            <template v-slot:content></template>
        </MenuOpcion> -->

        <section class="page-header">
            <div class="container">
                <h1 class="title text-light">PAGO TARJETA</h1>
            </div>
        </section>

        <div class="mt-0">
			<div class="row">
				<div class="col-12 col-md-8 bg-light shadow-md rounded p-4">
                    <div class="card row">
						<h5 class="card-header list-group-item-primary"><i class="fas fa-list-alt"></i> PAGO TARJETA</h5>

						<div class="p-2 col-6">
                            Referencia / Cliente
                            <b-form-input v-model="referencia" v-uppercase required trim></b-form-input>
                        </div>
                        <div class="p-2 col-6">
                            Importe
                            <b-form-input v-model="importe" required trim @keypress="onlyNumbers"></b-form-input>
                        </div>
                        <div class="list-group list-group-flush p-1 col-6">
                            <b-btn @click="pago">PAGO</b-btn>
						</div>

					</div>
                    <hr>
                </div>
            </div>
		</div>
	</div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

// import MenuOpcion from '@/components/MenuOpcion.vue'
//import hotelPrecios from '@/components/HotelPrecios.vue'

export default {
    name: 'pago-tarjeta',
    components: {
        // MenuOpcion,

        //hotelPrecios,
    },
    data() {
        return {
            modulo: 'pago-tarjeta',

            submitted: false,

            referencia: '',
            importe: 0,

            tppax: [
                { value:'20', id:'2A', text:'2 Adultos', pax: 2 },
            ],

        }
    },
    computed: {
         ...mapState(['G','auth','errores']),

        logueado() {
            return this.auth.logueado;
        },
        cta() {
            return this.auth.user;
        },

    },

    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        async pago(evt) {
            evt.preventDefault();
            this.submitted=true;

            //validar dnis y demas datos ???
            if (!this.validar()) return;

            //Preguntar
            let msg="Estas seguro <b>PAGO TARJETA</b> ?<br><br>"+
                "Referencia: <b>"+this.referencia+"</b><br>"+
                "Importe: <b>"+this.importe+" </b>€<br><br>" +
                "<b>Atención</b><br>Tras aceptar se debe abrir la pagina del BANCO.<br> " +
                "Aseguresé que su navegador permite ventanas emergentes."

            if (!await this.$root.$msgConf(msg,'RESERVA'))  return;

            //this.enviar();
            this.pagoBanco();
        },
        async enviar() {
            this.loading();
            var args=this.reserva;          //token y reserva
            args.sid=this.auth.token
            let r=await this.exec({api:'reservar', arg: args });
            this.loading(false);

            if (await this.error({r})) return;

            this.submitted=false;

            let m=(r.error ? r.datos : 'Petición/Reserva Nº ' + r.datos + 'guardada correctamente');
            this.modal({tit: this.modulo, msg: m}); //, time:0});

            if (r.error) return;

            this.reserva.id=r.datos; // localizador
            this.$router.push({name:'info-personal', params: {tab: 2}});
        },

        validar() {
            let m='';
            if (this.referencia=='') m+="<br>* Debe introducir Referencia / Cliente";
            if (this.importe<=0) m+="<br>* Debe introducir Importe Válido";

            if (m>'') this.modal({tit: this.modulo, msg: m, time:0});
            return (m=='');
        },

        async msgBanco(r) {

            this.pagoBanco();

            let msg=r.error ? r.datos :
                '<span class="text-justify">'+
                'Su Petición de Reserva Nº <b>'+this.reserva.id+'</b> se ha generado correctamente.<br><br>'+
                'Se ha procedido al pago con tarjeta de credito de <h3>'+this.reserva.tot+' €</h3><br>'+
                'En este proceso se ha abierto una nueva ventana de nuestro banco donde le solicitara de forma segura los datos de pago.<br>'+
                'En caso de no finalizar el proceso lo podra volver a iniciar en el apartado de reservas de la información personal, la petición de reserva tiene una caducidad de 30 minutos para activar de nuevo el proceso de pago.<br><br>'+
                'Si completa el proceso, ya dispondrá de su/s bonos correspondientes para los servicios contratados.<br>'+
                '<b><i>Importante:</b></i><br><small>Asegurese que su navegador permite ventanas emergentes (popup).</small>'+
                '</span>' ;
            //this.modal({tit:"Reserva", msg:msg,time:0});

            await this.$root.$msgBox(msg, this.modulo);

            //this.loading(false);
            //this.$router.push('/');
        },

        pagoBanco() {
            let url=this.G.url_tpv1;
            let arg=new Date().getTime()+'|0.'+this.referencia+'|'+this.importe;

            window.open(url+'?w='+arg,"_blank");
        },

        onlyNumbers ($event) {
            // console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            // only allow number and one dot
            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.importe.indexOf('.') != -1)) { // 46 is dot
                $event.preventDefault();
            }

            // restrict to 2 decimal places
            if(this.importe!=null && this.importe.indexOf(".")>-1 && (this.importe.split('.')[1].length > 1)) {
                $event.preventDefault();
            }
        },

         /* importeInput (e) { //@input="importeInput"
            let stringValue = e.target.value.toString();
            let regex = /^\d*(\.\d{1,2})?$/
            if(!stringValue.match(regex) && this.price!== '') {
                this.importe = this.previousPrice
            }
            this.previousPrice = this.importeprice
        } */


//////////////////////////////////////////

    },
    created() {
        /* if (this.turno.id==undefined) {
            this.$router.push('/hoteles');
        } */
        //console.log('*reservar.created',this.hotel.hot,this.hotel.imagenes,this.turno.id);
    },
    mounted() {

        //turno seleccionado
        this.seleccionado();

        //datos omision cliente
        this.datos_cuenta(this.cta);
    }
}
</script>